import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgContract = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21 11.0254C20.6667 10.9921 20.329 11.0042 19.9873 11.0625C19.6457 11.1208 19.3166 11.225 19 11.375V4H8V16H14L12 18V22H6C5.16667 22 4.45833 21.7083 3.875 21.125C3.29167 20.5417 3 19.8333 3 19V16H6V2H21V11.0254ZM20.5752 13C20.7751 13 20.9671 13.0373 21.1504 13.1123C21.3336 13.1873 21.5005 13.3003 21.6504 13.4502L22.5752 14.375C22.7085 14.525 22.8127 14.6917 22.8877 14.875C22.9627 15.0582 23 15.2416 23 15.4248C23 15.608 22.967 15.7957 22.9004 15.9873C22.8337 16.1789 22.7251 16.35 22.5752 16.5L17.0752 22H14V18.9248L19.5254 13.4248C19.6753 13.275 19.8422 13.1662 20.0254 13.0996C20.2086 13.0331 20.392 13 20.5752 13ZM19.625 15.4502L20.5752 16.4004L21.5 15.4248L20.5752 14.5L19.625 15.4502ZM18 12H9V10H18V12ZM18 9H9V7H18V9Z" })
});
export default SvgContract;
